import React, { useState } from "react";
import { Card, CardBody, Input, Label, Button } from "reactstrap";

const Detail_RewardsPoints = ({ points = 0, pointsHistory = [], onUpdate, isPointsUpdating = false }) => {
  const [value, setValue] = useState("");
  const [mode, setMode] = useState(null); // "add" or "subtract"
  const [notes, setNotes] = useState("");

  const handleSubmit = () => {
    const amount = parseInt(value, 10);
    if (!amount || !mode) return;

    const delta = mode === "subtract" ? -Math.abs(amount) : Math.abs(amount);
    if (onUpdate) onUpdate(delta, notes);

    setValue("");
    setNotes("");
    setMode(null);
  };


  return (
    <Card style={{ background: "#eee", padding: "1rem" }}>
      <CardBody>
        <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
          <div>
            <div><strong>Points Balance:</strong> {points}</div>
            <div style={{ marginTop: "0.5rem" }}>
              <strong>History:</strong>
              <ul style={{ paddingLeft: "1rem", marginTop: "0.25rem" }}>
                {pointsHistory
                  ?.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
                  .slice(0, 5)
                  .map((item, idx) => (
                    <li key={idx}>
                      <strong>
                        {item?.amount != null ? `${item.amount > 0 ? '+' : ''}${item.amount} pts` : ''}
                      </strong>
                      {item?.note ? ` — ${item.note}` : ''}
                      <br />
                      <em>{item?.date ? new Date(item.date).toLocaleString() : 'No timestamp'}</em>
                    </li>
                ))}
              </ul>
            </div>
          </div>

          <div style={{ minWidth: "260px" }}>
            <Label>Points:</Label>
            <Input
              type="number"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              placeholder="Enter amount"
            />

            <div className="my-2 d-flex gap-2">
              <div>
                <input
                  type="radio"
                  name="pointsMode"
                  checked={mode === "add"}
                  tabIndex={0}
                  onClick={() => {
                    setMode("add");
                  }}
                  style={{ marginRight: "4px", zIndex: 1000, pointerEvents: "auto" }}
                />
                <label>Add</label>
              </div>

              <div>
                <input
                  type="radio"
                  name="pointsMode"
                  checked={mode === "subtract"}
                  onClick={() => {
                    setMode("subtract");
                  }}
                  style={{ marginRight: "4px" }}
                />
                <label>Subtract</label>
              </div>
            </div>

            <Label>Notes:</Label>
            <Input
              type="text"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Reason for change"
            />

            <Button
              color="primary"
              className="mt-2"
              onClick={handleSubmit}
              disabled={isPointsUpdating || !value || !mode}
            >
              {isPointsUpdating ? "Updating..." : "Update"}
            </Button>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default Detail_RewardsPoints;
